import type { PromotePageMainData } from '../../types';

import { getComboBanditExpAmountChoices } from './getComboBanditExpAmountChoices';

export function getAmountChoices(
	mainData: PromotePageMainData,
	psfComboBanditStaticAmount?: string,
): { amountChoices: readonly number[] } {
	const amountChoices =
		mainData.petition.bandits?.contextualPromotionButtons?.selectedVariant?.data.amounts ||
		mainData.promotionCountrySettings.amountChoices;

	if (!psfComboBanditStaticAmount) return { amountChoices };
	const psfStaticAmount = Number(psfComboBanditStaticAmount);
	if (Number.isNaN(psfStaticAmount) || psfStaticAmount <= 0) return { amountChoices };
	const comboBanditExpAmountChoices = getComboBanditExpAmountChoices({
		revenueBanditsPsfComboButtonAmounts: mainData.revenueBanditsPsfComboButtonAmounts,
		amountChoices,
		psfStaticAmount,
	});

	return { amountChoices: comboBanditExpAmountChoices };
}
